import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ContentCalendar, CreateCalendarRequest } from '@seo/types';
import { apiPost } from '@/lib/api';

export function useCreateCalendar() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateCalendarRequest) =>
      apiPost<ContentCalendar>('/v1/calendars', input, {
        headers: { 'idempotency-key': crypto.randomUUID() },
      }),
    onSuccess: (cal) => {
      void qc.invalidateQueries({ queryKey: ['calendars'] });
      qc.setQueryData(['calendar', cal.id], cal);
    },
  });
}
